import React from 'react';
import { Skeleton } from '@ublend-npm/aulaui-core';

type OmniSearchLoadingProps = {
  quantity: number;
};

export const OmniSearchLoading = ({ quantity }: OmniSearchLoadingProps) => (
  <>
    {Array.from(Array(quantity), (_, i) => i + 1).map((key) => (
      <Skeleton
        key={key}
        role="status"
        kind="rounded"
        height={100}
        sx={{ marginBottom: 2 }}
      />
    ))}
  </>
);

OmniSearchLoading.displayName = 'OmniSearchLoading';
